const geoLayers = [
    {
        id: "state",
        label: "States",
        label2: "states",
    },
    {
        id: "county",
        label: "Counties",
        label2: "counties",
    },
    {
        id: "place",
        label: "Towns and Cities (Census Designated Places)",
        label2: "cities or towns",
    },
    {
        id: "tract",
        label: "Neighborhoods (Census Tracts)",
        label2: "tracts",
    },
    {
        id: "cd",
        label: "Congressional Districts",
        label2: "congressional districts",
    },
    {
        id: "tribal",
        label: "American Indian and Native Areas",
        label2: "American Indian areas",
    },
    {
        id: "portion",
        label: "Metro and Rural Portions of States",
        label2: "metro and rural portions",
    },
    // {
    //     id: "csa",
    //     label: "Groups of Counties (Combined Statistical Areas)",

    //     label2: "combined statistical areas",
    // },
    {
        id: "cousub",
        label: "Parts of Counties (County Subdivisions)",
        label2: "county subdivisions",
    },
];

export { geoLayers };
